import type { LinkData } from '@wix/thunderbolt-becky-types'
import type { LinkUtils } from '@wix/thunderbolt-symbols'

/**
 * Resolves the site-owner-configured redirect Link to the same-site href used by
 * navigation. Returns undefined when there's no link or it can't be resolved.
 */
export const resolvePostAuthRedirectHref = (linkUtils: LinkUtils, link?: LinkData): string | undefined => {
	if (!link) {
		return undefined
	}
	try {
		const slug = linkUtils.getLinkUrlFromDataItem(link as Parameters<typeof linkUtils.getLinkUrlFromDataItem>[0])
		return linkUtils.getLinkProps(slug).href
	} catch {
		return undefined
	}
}
